import(/* webpackMode: "eager", webpackExports: ["FreeEsimWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
